import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted, ref } from 'vue'
import {
    DatatableConfigDescriptor,
    KhEditableList,
    KhFormulaManager,
    KhFormulaSchemaRoot,
    Nullable,
} from '@internal-libraries/kheops-ui-lib'
import { useTranslate, useTranslation } from '../../../../i18n/useTranslation'
import { useConfigStore } from '../../../../Store/configStore'

interface ClvrConfigElementListItem {
    data: string
}

export interface ClvrConfigElementListProps {
    value: string[]
    configKey: string
    context: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ClvrConfigElementList',
  props: {
    value: { default: () => [] },
    configKey: null,
    context: null
  },
  emits: ["input"],
  setup(__props: any, { emit: emits }: { emit: ({
    (e: 'input', value: unknown): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as { value: string[], configKey: string, context: string }




const configStore = useConfigStore()
const $t = useTranslate()
const translation = useTranslation()
const translationLoading = ref(true)
const managerForm = ref<KhFormulaManager>()
let currentItem: Nullable<ClvrConfigElementListItem> = null

const datatableConfig = computed<DatatableConfigDescriptor>(() => ({
    headers: [{ text: getTranslation('col_1_title'), value: 'data', sortable: false }],
    hideDefaultFooter: true,
}))

const listItems = computed<ClvrConfigElementListItem[]>(() => {
    return props.value.map(item => ({
        data: item,
    }))
})

const translationPrefix = computed<string>(() => props.configKey.replaceAll(' ', '-'))
const schema = computed<KhFormulaSchemaRoot>(() => {
    return {
        children: [
            {
                type: 'field',
                name: 'data',
                errorName: getTranslation('error_name'),
                element: 'KhInput',
                validations: [{ rule: 'required' }],
                props: {
                    label: getTranslation('col_1_title'),
                    inputType: 'textfield',
                },
            },
        ],
    }
})

onMounted(() => {
    translation.i18next.loadNamespaces('clevehr').then(() => {
        translationLoading.value = false
    })
})

function initSchema(manager: KhFormulaManager): void {
    managerForm.value = manager
}

function onStartEdition(item: ClvrConfigElementListItem): void {
    currentItem = item
}
function onStartCreation(): void {
    currentItem = null
}
function onSubmit(submitedItem: ClvrConfigElementListItem): void {
    let newList: ClvrConfigElementListItem[] = []

    const foundElement = listItems.value.find(item => item.data === submitedItem.data)

    //update or create mode
    if (currentItem) {
        // check if the data is different but collide with existing data
        if (foundElement && currentItem.data !== submitedItem.data) {
            alert(getTranslation('add_exist'))
            return
        }

        const itemEditIndex = listItems.value.findIndex(item => item.data === currentItem?.data)
        newList = [...listItems.value]
        newList[itemEditIndex] = submitedItem
    } else {
        if (foundElement) {
            alert(getTranslation('add_exist'))
            return
        }

        newList = [...listItems.value, submitedItem]
    }

    emits(
        'input',
        newList.map(item => item.data),
    )
}
function onDelete(deleteItem: ClvrConfigElementListItem): void {
    const itemDeleteIndex = listItems.value.findIndex(item => item.data === deleteItem.data)
    const newList = [...listItems.value]
    newList.splice(itemDeleteIndex, 1)
    configStore.checkConfigListValueInUse(props.context, props.configKey.replaceAll(' ', '-'), deleteItem.data)

    emits(
        'input',
        newList.map(item => item.data),
    )
}

function getTranslation(translationKey: string) {
    return $t.value(`${props.context}:${translationPrefix.value}-${translationKey}`)
}

return { __sfc: true,props, emits, configStore, $t, translation, translationLoading, managerForm, currentItem, datatableConfig, listItems, translationPrefix, schema, initSchema, onStartEdition, onStartCreation, onSubmit, onDelete, getTranslation, KhEditableList }
}

})